var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefresh({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1176_6146)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.442086 6.7182C0.53577 6.75568 0.644419 6.75568 0.738104 6.71072L3.66445 5.38055C3.85179 5.29063 3.93047 5.06581 3.84055 4.87848C3.75438 4.69863 3.54081 4.61618 3.35719 4.69863L1.30762 5.63161C2.28557 2.70526 5.00958 0.749371 8.14575 0.749371C11.4318 0.749371 14.3057 2.94507 15.1337 6.08872C15.1862 6.28729 15.3923 6.40722 15.5908 6.35474C15.7894 6.30229 15.9093 6.0962 15.8569 5.89763C14.9426 2.428 11.7727 0 8.14571 0C4.68733 0 1.67853 2.15822 0.591939 5.38807L-0.269839 3.23361C-0.333525 3.03876 -0.547099 2.93011 -0.74195 2.99379C-0.936801 3.05748 -1.04545 3.27105 -0.981764 3.46591C-0.978005 3.4809 -0.970523 3.49587 -0.963041 3.51087L0.232235 6.50839C0.269716 6.60207 0.344643 6.68076 0.442086 6.7182ZM16.9772 12.2486C16.9734 12.2412 16.9697 12.2336 16.9697 12.2262L15.7744 9.22864C15.737 9.13496 15.662 9.05627 15.5646 9.01883C15.4709 8.98135 15.3623 8.98511 15.2686 9.02631L12.3423 10.3565C12.1512 10.4352 12.0612 10.6562 12.1399 10.8473C12.2186 11.0384 12.4397 11.1283 12.6308 11.0496L12.6532 11.0384L14.7028 10.1054C13.7174 13.0318 10.9896 14.9877 7.85721 14.9877C4.57116 14.9877 1.69729 12.792 0.869234 9.64831C0.816789 9.44973 0.610697 9.32981 0.412122 9.38229C0.213548 9.43474 0.093623 9.64083 0.146103 9.8394C1.0566 13.3128 4.23025 15.737 7.85725 15.737C11.3156 15.737 14.3207 13.5788 15.411 10.349L16.2728 12.5034C16.344 12.6983 16.5576 12.7994 16.7524 12.7282C16.9472 12.6571 17.0484 12.4435 16.9772 12.2486Z",
    fill: "#767C8F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1176_6146"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/Refresh.9fff02064e0c76ffa5d09d91fcdee923.svg";
export { ForwardRef as ReactComponent };